import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useState } from "react";
import styles from "./styles.module.scss";
import { CircularProgress, FormControl, Icon, TextField } from "@mui/material";
import { formControlStyles, labelStyles } from "../data";
import SmallFont from "Root/profile/components/common/SmallFont";
import { Close } from "@mui/icons-material";
import Lottie from "lottie-react";
import animationData from "./animation.json";
const PromoComponentNew = ({ applyPromo, removePromo, error, shippingMethod, discountStr = [], hidePromo, }) => {
    const [promo, setPromo] = useState("");
    const [loading, setLoading] = useState(false);
    const [promoLoaded, setPromoLoaded] = useState(false);
    const onRemovePromo = async (promo) => {
        try {
            setLoading(true);
            setPromoLoaded(false);
            await removePromo(promo, shippingMethod);
            setPromoLoaded(true);
            setTimeout(() => {
                setPromoLoaded(false);
            }, 3000);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
            setPromo("");
        }
    };
    const onApplyPromo = async () => {
        try {
            setLoading(true);
            setPromoLoaded(false);
            await applyPromo(promo, shippingMethod);
            setPromoLoaded(true);
            setTimeout(() => {
                setPromoLoaded(false);
            }, 3000);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
            setPromo("");
        }
    };
    return (_jsxs("div", { className: styles.promo_wrapper, children: [_jsxs("div", { className: styles.promo, children: [_jsx(FormControl, { error: !!error, fullWidth: true, sx: !error ? formControlStyles : labelStyles, children: _jsx(TextField, { InputLabelProps: {
                                style: labelStyles,
                            }, InputProps: {
                                style: labelStyles,
                            }, value: promo, helperText: error, label: "Gift card or promo code", variant: "outlined", onChange: (event) => setPromo(event.target.value), error: !!error }) }), _jsxs("button", { disabled: loading, onClick: onApplyPromo, className: [styles.apply, loading && styles.disabled].join(" "), children: [loading && _jsx(CircularProgress, { size: 25, className: styles.spinner }), !loading && !promoLoaded && (_jsx("svg", { width: "15", height: "10", viewBox: "0 0 15 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M0.519531 4.99993H13.4795M13.4795 4.99993L9.02782 0.679932M13.4795 4.99993L9.02782 9.31993", stroke: "white", strokeWidth: "1.5" }) })), promoLoaded && _jsx(Lottie, { animationData: animationData, loop: false })] })] }), !hidePromo && (_jsx("div", { className: styles.codes, children: discountStr &&
                    discountStr?.map((item) => item && (_jsxs("div", { className: styles.item, children: [_jsx(SmallFont, { children: item }), _jsx(Icon, { onClick: () => onRemovePromo(item), className: styles.remove, fontSize: "small", children: _jsx(Close, {}) })] }, item))) }))] }));
};
export default PromoComponentNew;
